import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import ca from './translations/ca.json';
import en from './translations/en.json';

// TRAMA va en anglès, i el català ja hi és.
//
// Muntat igual que a LUCIFER, que és l'única altra aplicació del servidor amb traduccions: si
// algun dia s'han de mantenir totes dues, val més que funcionin igual.
//
// La diferència és quin idioma mana. Aquí `en`, perquè és el que hi ha escrit a la resta de
// pantalles —vegeu el CLAUDE.md: `Dashboard`, `Models`, `ModelEditor`, `Simulations` i
// `Exercises` encara tenen el text a dins—. Posar `ca` per defecte avui deixaria l'aplicació a
// mitja llengua, que és pitjor que tenir-la sencera en una de sola.
//
// Per veure com queda en català: `localStorage.setItem('language','ca')` i recarregar.
const IDIOMES = ['en', 'ca'];
const PER_DEFECTE = 'en';

const idiomaInicial = () => {
  const desat = localStorage.getItem('language');
  // Es comprova que sigui un dels que hi ha. Un valor estrany a localStorage deixaria
  // l'aplicació en un idioma inexistent sense manera de sortir-ne des de la interfície.
  return IDIOMES.includes(desat) ? desat : PER_DEFECTE;
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ca: { translation: ca }
    },
    lng: idiomaInicial(),
    fallbackLng: PER_DEFECTE,
    supportedLngs: IDIOMES,
    interpolation: { escapeValue: false }
  });

i18n.on('languageChanged', (lng) => localStorage.setItem('language', lng));

export default i18n;
